__turbopack_context__.v({
  "container": "RightOfWithdrawalBlok-module__jdeDnG__container",
  "error": "RightOfWithdrawalBlok-module__jdeDnG__error",
  "form": "RightOfWithdrawalBlok-module__jdeDnG__form",
  "notice": "RightOfWithdrawalBlok-module__jdeDnG__notice",
  "root": "RightOfWithdrawalBlok-module__jdeDnG__root",
  "success": "RightOfWithdrawalBlok-module__jdeDnG__success",
  "successMeta": "RightOfWithdrawalBlok-module__jdeDnG__successMeta",
  "successText": "RightOfWithdrawalBlok-module__jdeDnG__successText",
  "successTitle": "RightOfWithdrawalBlok-module__jdeDnG__successTitle",
  "summary": "RightOfWithdrawalBlok-module__jdeDnG__summary",
});
